import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MedReviewComponent } from './med-review.component';
import { MedReviewBoardComponent } from './components/med-review-board/med-review-board.component';
import { AuthGuard } from '../../../core/auth';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: MedReviewComponent,
  },
  {
    canActivate: [AuthGuard],
    path: 'board/:id',
    component: MedReviewBoardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MedReviewRoutingModule {}
